export class SuspectsAltHeatMap {
    demandForPlantHeatMap: Array<any>;
    apPlantsData: Array<any>;
    competitorPlantsData: Array<any>;
    competitorAPPlantsData: Array<any>;
    proposedPlantsData: Array<any>;
    bullsEyeData: Array<any>;
    globalIndSegments: Array<any>;
    constructor() {
        this.demandForPlantHeatMap = [];
        this.apPlantsData = [];
        this.competitorPlantsData = [];
        this.competitorAPPlantsData = [];
        this.proposedPlantsData = [];
    }
}